import { VotingOption } from './Proposal';
export const sampleProposal = () => {
    return {
        id: 'proposal-id',
        title: 'Proposal title as presented in official AGM documentation',
        formattedDescription: 'A **Markdown** formatted description of the proposal, as presented in *official* AGM documentation',
        votingOptions: [VotingOption.For, VotingOption.Against, VotingOption.Abstain],
    };
};
